import { Order, OrderRepository } from "../domain/order";
import { client } from "@/client";

const BASE_URL = `${client.OPENBASS}/v1/orders`;

export class HttpOrdersRepository implements OrderRepository {
  async getAll(id: string, isAdmin: boolean = false): Promise<Order[]> {
    const url = isAdmin ? `${BASE_URL}?storeId=${id}` : `${BASE_URL}?shopperId=${id}`;
    const res = await fetch(url, {
      credentials: "include",
    });

    if (!res.ok) throw new Error("Failed to fetch orders");
    const data = await res.json();
    return data.response;
  }

  async get(id: string): Promise<Order | null> {
    const res = await fetch(`${BASE_URL}/${id}`, {
      credentials: "include",
    });

    if (res.status === 404) return null;
    if (!res.ok) throw new Error("Failed to fetch order");
    const data = await res.json();
    return data.response;
  }

  async create(order: Order): Promise<Order> {
    const res = await fetch(`${BASE_URL}`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(order),
    });

    if (!res.ok) throw new Error("Failed to create order");
    const data = await res.json();
    return data.response;
  }

  async update(id: string, order: Partial<Order>): Promise<Order> {
    const res = await fetch(`${BASE_URL}/${id}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(order),
    });

    if (!res.ok) throw new Error("Failed to update order");
    const data = await res.json();
    return data.response;
  }

  async delete(id: string): Promise<void> {
    const res = await fetch(`${BASE_URL}/${id}`, {
      method: "DELETE",
      credentials: "include",
    });

    if (!res.ok) throw new Error("Failed to delete order");
  }

  async getAllByShopper(shopperId: string): Promise<Order[]> {
    const res = await fetch(`${BASE_URL}/shopper/${shopperId}`, {
      credentials: "include",
    });

    if (!res.ok) throw new Error("Failed to fetch shopper orders");
    const data = await res.json();
    return data.response;
  }

  async getAllByAdmin(): Promise<Order[]> {
    const res = await fetch(`${BASE_URL}`, {
      credentials: "include",
    });

    if (!res.ok) throw new Error("Failed to fetch admin orders");
    const data = await res.json();
    return data.response;
  }

  async getAllComplete(): Promise<Order[]> {
    const res = await fetch(`${BASE_URL}/complete`, {
      credentials: "include",
    });

    if (!res.ok) throw new Error("Failed to fetch complete orders");
    const data = await res.json();
    return data.response;
  }

  async getAllCompleteByShopper(shopperId: string): Promise<Order[]> {
    const res = await fetch(`${BASE_URL}/complete/shopper/${shopperId}`, {
      credentials: "include",
    });

    if (!res.ok) throw new Error("Failed to fetch complete shopper orders");
    const data = await res.json();
    return data.response;
  }

  async getAllCompleteByAdmin(): Promise<Order[]> {
    const res = await fetch(`${BASE_URL}/complete/admin`, {
      credentials: "include",
    });

    if (!res.ok) throw new Error("Failed to fetch complete admin orders");
    const data = await res.json();
    return data.response;
  }
}
